export const hero = {
    pt: {
        subtitle: "Estúdio de Desenvolvimento de Jogos",
        description: "Desenvolvemos jogos e experiências interativas que unem inovação, arte e tecnologia.<br>Criamos com paixão e qualidade desde 2020.",
        projects: "Ver Projetos",
        contact: "Entre em contato",
    },
    en: {
        subtitle: "Game Development Studio",
        description: "Developing games and interactive experiences that unite innovation, art, and technology.<br>Crafted with passion and quality since 2020.",
        projects: "See Projects",
        contact: "Contact us",
    }
}